import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Popover,
  Box,
  Typography,
  Button,
  Grid,
  Skeleton,
  ListItem,
  ListItemText,
  List,
} from "@mui/material";
import restype from "../../assets/barber.jpg";
import { updateReservationType } from "../../store/slice/Addguest.slice";
import { setselectedDate, setselectedProffesionalDetails, setselectedTime } from "../../store/slice/Salon.slice";
import { useTheme } from "@emotion/react";
const IMG_URL = process.env.REACT_APP_API_LOCAL_IMG_URL;
const StylishComponent = ({ Ref, isOpen, handleClose, loader }) => {
  const [anchorOriginVert, setAnchorOriginVert] = useState('bottom'); // default
  const [transformOriginVert, setTransformOriginVert] = useState('top'); // default
  const theme=useTheme()
  const{css}=useSelector((store)=> store?.widgetSettings)
  const stylistCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Stylist"
  )?.fields
  useEffect(() => {
    if (Ref?.current) {
      const rect = Ref?.current?.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // If input is near the bottom 150px of the viewport, show popover above
      if (rect.bottom + 400 > viewportHeight) { // 400 ~ popover height
        setAnchorOriginVert('top');
        setTransformOriginVert('bottom');
      } else {
        setAnchorOriginVert('bottom');
        setTransformOriginVert('top');
      }
    }
  }, [isOpen, Ref]);




  const { proffesionalDetails, treatmentType, selectedProffesionalDetails,languageWords} =
    useSelector((store) => store?.salon);

  const dispatch = useDispatch();
useEffect(()=>{
  dispatch(setselectedProffesionalDetails((languageWords?.NoPrefrence)))
},[proffesionalDetails])
  return (
    <Popover
    open={isOpen}
    anchorEl={Ref?.current}
    onClose={handleClose}
    anchorOrigin={{
      vertical: anchorOriginVert,
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: transformOriginVert,
      horizontal: 'center',
    }}
    PaperProps={{
      sx: {
        borderRadius: 2,
        boxShadow: 3,
        overflow: 'hidden',
backgroundColor: stylistCss?.stylistBgMainClr,
        mt: 1,
        minWidth: 220,
        width:350,
        overflowY: 'scroll',     // enable scrolling
        scrollbarWidth: 'none',  // Firefox
        '-ms-overflow-style': 'none', // IE 10+
        '&::-webkit-scrollbar': {
          display: 'none',       // Chrome, Safari, Edge
        },  
      },
    }}
    disableEnforceFocus
    disableAutoFocus 
    disableRestoreFocus
  >
                <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            my: 1.5,
          }}
        >
          <Typography
            sx={{
              color: stylistCss?.stylistHeadingClr,
              fontSize: "14px",
              fontWeight: "bold",
              px:2,
            }}
          >
            {languageWords?.availableStylist || "Available Stylist"}
          </Typography>
          </Box>
    <List disablePadding>
    <ListItem
            disablePadding
            onClick={(e) =>{
              e.stopPropagation();
              dispatch(setselectedDate(""));
              dispatch(setselectedTime(""));
              dispatch(setselectedProffesionalDetails(languageWords?.NoPrefrence ));
              handleClose();
            }}
            selected={selectedProffesionalDetails == (languageWords?.NoPrefrence )}
            sx={{
              px: 2,
              py: 1.5,
              backgroundColor: selectedProffesionalDetails == (languageWords?.NoPrefrence || 'No Prefrence')
              ? stylistCss?.stylistItemSelectBgClr
              : stylistCss?.stylistItemBgClr,
            color: selectedProffesionalDetails == (languageWords?.NoPrefrence || 'No Prefrence')
              ? stylistCss?.stylistItemSelectTxtClr
              : stylistCss?.stylistItemTxtClr,
            
            
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              "&:hover": {
                backgroundColor: stylistCss?.stylistBghover,
                color: stylistCss?.stylistTxtHover,
              },
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontWeight: selectedProffesionalDetails == (languageWords?.NoPrefrence || 'No Prefrence') ? 'bold' : 'normal',
                textAlign: 'center',
                fontSize: '0.95rem',
              }}
              primary={languageWords?.NoPrefrence ||   'No Prefrence'}
            />
          </ListItem>
      { proffesionalDetails?.map((table) => {
        const isSelected = selectedProffesionalDetails?.idSalonProfessional === table?.idSalonProfessional;
        return (
          <ListItem
            key={table.idSalonProfessional}
            disablePadding
            onClick={(e) =>{
              e.stopPropagation();
              dispatch(setselectedDate(""));
              dispatch(setselectedTime(""));
              dispatch(setselectedProffesionalDetails(table));
              handleClose();
            }}
            selected={isSelected}
            sx={{
              px: 2,
              py: 1.5,
              backgroundColor: isSelected ? stylistCss?.stylistItemSelectBgClr
              : stylistCss?.stylistItemBgClr,
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              "&:hover": {
                backgroundColor: stylistCss?.stylistBghover,
                color: stylistCss?.stylistTxtHover,
              },
              color: isSelected ?   stylistCss?.stylistItemSelectTxtClr
              : stylistCss?.stylistItemTxtClr,
            
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontWeight: isSelected ? 'bold' : 'normal',
                textAlign: 'center',
                fontSize: '0.95rem',
              }}
              primary={  table?.firstName + " " + table?.lastName}
            />
          </ListItem>
        );
      })}
    </List>
  </Popover>
  );
};
export default StylishComponent;
